import { FIELD_TYPES, validateBirthdate, validateVatID, } from '@wix/form-fields';
export const runAdditionalValidation = ({ form, values, externalData, }) => {
    const additionalErrors = form.fields?.reduce((acc, field) => {
        const fieldTarget = field.target;
        if (!fieldTarget) {
            return acc;
        }
        const fieldType = field?.view?.fieldType;
        const fieldValue = values[fieldTarget];
        const validateField = ADDITIONAL_FIELD_VALIDATION[fieldType];
        const error = validateField?.({
            value: fieldValue,
            target: fieldTarget,
            externalData,
        });
        if (error) {
            acc[fieldTarget] = error;
        }
        return acc;
    }, {});
    return additionalErrors;
};
const ADDITIONAL_FIELD_VALIDATION = {
    [FIELD_TYPES.TEXT_INPUT]: null,
    [FIELD_TYPES.CHECKBOX_GROUP]: null,
    [FIELD_TYPES.RADIO_GROUP]: null,
    [FIELD_TYPES.DONATION]: null,
    [FIELD_TYPES.DROPDOWN]: null,
    [FIELD_TYPES.URL_INPUT]: null,
    [FIELD_TYPES.NUMBER_INPUT]: null,
    [FIELD_TYPES.QUIZ_NUMBER]: null,
    [FIELD_TYPES.QUIZ_SHORT_TEXT]: null,
    [FIELD_TYPES.QUIZ_LONG_TEXT]: null,
    [FIELD_TYPES.QUIZ_MULTI_CHOICE]: null,
    [FIELD_TYPES.QUIZ_IMAGE_CHOICE]: null,
    [FIELD_TYPES.QUIZ_SINGLE_CHOICE]: null,
    [FIELD_TYPES.QUIZ_FILE_UPLOAD]: null,
    [FIELD_TYPES.FILE_UPLOAD]: null,
    [FIELD_TYPES.SIGNATURE]: null,
    [FIELD_TYPES.CONTACTS_EMAIL]: null,
    [FIELD_TYPES.CONTACTS_PHONE]: null,
    [FIELD_TYPES.CHECKBOX]: null,
    [FIELD_TYPES.DATE_INPUT]: null,
    [FIELD_TYPES.DATE_TIME_INPUT]: null,
    [FIELD_TYPES.TIME_INPUT]: null,
    [FIELD_TYPES.DATE_PICKER]: null,
    [FIELD_TYPES.CONTACTS_COMPANY]: null,
    [FIELD_TYPES.CONTACTS_POSITION]: null,
    [FIELD_TYPES.CONTACTS_TAX_ID]: null,
    [FIELD_TYPES.CONTACTS_FIRST_NAME]: null,
    [FIELD_TYPES.CONTACTS_LAST_NAME]: null,
    [FIELD_TYPES.CONTACTS_ADDRESS]: null,
    [FIELD_TYPES.CONTACTS_BIRTHDATE]: validateBirthdate,
    [FIELD_TYPES.TEXT_AREA]: null,
    [FIELD_TYPES.CONTACTS_SUBSCRIBE]: null,
    [FIELD_TYPES.NESTED_FORM]: null,
    [FIELD_TYPES.MULTILINE_ADDRESS]: null,
    [FIELD_TYPES.MLA_COUNTRY]: null,
    [FIELD_TYPES.MLA_CITY]: null,
    [FIELD_TYPES.MLA_ADDRESS_LINE]: null,
    [FIELD_TYPES.MLA_ADDRESS_LINE_2]: null,
    [FIELD_TYPES.MLA_POSTAL_CODE]: null,
    [FIELD_TYPES.MLA_SUBDIVISION]: null,
    [FIELD_TYPES.MLA_STREET_NAME]: null,
    [FIELD_TYPES.MLA_STREET_NUMBER]: null,
    [FIELD_TYPES.MLA_APARTMENT]: null,
    [FIELD_TYPES.FULL_NAME_FIRST_NAME]: null,
    [FIELD_TYPES.FULL_NAME_LAST_NAME]: null,
    [FIELD_TYPES.FULL_NAME]: null,
    [FIELD_TYPES.DEXT_TEXT_INPUT]: null,
    [FIELD_TYPES.DEXT_NUMBER_INPUT]: null,
    [FIELD_TYPES.DEXT_CHECKBOX]: null,
    [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: null,
    [FIELD_TYPES.DEXT_TAGS]: null,
    [FIELD_TYPES.DEXT_RATING_INPUT]: null,
    [FIELD_TYPES.ECOM_ADDITIONAL_INFO]: null,
    [FIELD_TYPES.ECOM_ADDRESS]: null,
    [FIELD_TYPES.ECOM_PHONE]: null,
    [FIELD_TYPES.ECOM_FULL_NAME]: null,
    [FIELD_TYPES.ECOM_COMPANY_NAME]: null,
    [FIELD_TYPES.ECOM_EMAIL]: null,
    [FIELD_TYPES.ECOM_SUBSCRIPTION]: null,
    [FIELD_TYPES.DEXT_TEXT_AREA]: null,
    [FIELD_TYPES.DEXT_DROPDOWN]: null,
    [FIELD_TYPES.DEXT_RADIO_GROUP]: null,
    [FIELD_TYPES.DEXT_URL_INPUT]: null,
    [FIELD_TYPES.DEXT_EMAIL]: null,
    [FIELD_TYPES.DEXT_PHONE]: null,
    [FIELD_TYPES.DEXT_DATE_PICKER]: null,
    [FIELD_TYPES.VAT_ID]: validateVatID,
    [FIELD_TYPES.PRODUCT_LIST]: null,
    [FIELD_TYPES.RATING_INPUT]: null,
    [FIELD_TYPES.TAGS]: null,
    [FIELD_TYPES.PAYMENT_INPUT]: null,
    [FIELD_TYPES.FIXED_PAYMENT]: null,
    [FIELD_TYPES.BOOKINGS_FIRST_NAME]: null,
    [FIELD_TYPES.BOOKINGS_LAST_NAME]: null,
    [FIELD_TYPES.BOOKINGS_EMAIL]: null,
    [FIELD_TYPES.BOOKINGS_PHONE]: null,
    [FIELD_TYPES.BOOKINGS_ADDRESS]: null,
    [FIELD_TYPES.APPOINTMENT]: null,
    [FIELD_TYPES.PASSWORD]: null,
    [FIELD_TYPES.SERVICES_DROPDOWN]: null,
    [FIELD_TYPES.SERVICES_MULTI_CHOICE]: null,
    [FIELD_TYPES.EVENTS_RSVP]: null,
    [FIELD_TYPES.EVENTS_REPEATER]: null,
};
//# sourceMappingURL=additional-field-validation.js.map